import React, { Component } from "react";
import Footer from "../../components/footer/Footer";
import Header from "../../components/header/Header";
import TopButton from "../../components/topButton/TopButton";
import Certifications from "../../containers/certifications/Certifications";
import DemoReel from "../../containers/demoReel/DemoReel";
import Greeting from "../../containers/greeting/Greeting";
import Skills from "../../containers/skills/Skills";
import Contact from "../../pages/contact/ContactComponent";
import { certifications, demoReel } from "../../portfolio";

class Home extends Component {
  render() {
    return (
      <div>
        <Header theme={this.props.theme} />
        <Greeting theme={this.props.theme} />
        <Skills theme={this.props.theme} />
        {demoReel && <DemoReel theme={this.props.theme} />}
        {certifications.certifications.length > 0 && (
          <Certifications theme={this.props.theme} />
        )}
        <Contact theme={this.props.theme} />
        <Footer theme={this.props.theme} />
        <TopButton theme={this.props.theme} />
      </div>
    );
  }
}

export default Home;
